import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from 'react-i18next'
import { FiUsers, FiDatabase, FiShoppingCart, FiFileText, FiArrowRight } from 'react-icons/fi';



const Main = () => {

    const {t} = useTranslation()
    return (
        <div>
            {process.env.REACT_APP_NOT_SECRET_CODE}
            <div className="main-header">
                <div className="main-logo">
                    <img
                        src={require("../img/logo.png")}
                        alt="Медгенетика.рф"
                    />
                </div>
                <h1 className="main-title">{t('top_biocollection_name')}</h1>
            </div>
            <div className="main-intro-text">{t("index_text")}</div>

            {/* Quick Start Section */}
            <div className="quick-start-section">
                <h3 className="quick-start-title">{t('quick_start_title')}</h3>
                <div className="quick-start-grid">
                    <Link to="/patients" className="quick-start-card">
                        <div className="quick-start-icon"><FiUsers size={24} /></div>
                        <div className="quick-start-content">
                            <h4>{t('patient_button')}</h4>
                            <p>{t('quick_start_patients_desc')}</p>
                        </div>
                        <FiArrowRight className="quick-start-arrow" size={18} />
                    </Link>

                    <Link to="/assays" className="quick-start-card">
                        <div className="quick-start-icon"><FiDatabase size={24} /></div>
                        <div className="quick-start-content">
                            <h4>{t('assay_button')}</h4>
                            <p>{t('quick_start_assays_desc')}</p>
                        </div>
                        <FiArrowRight className="quick-start-arrow" size={18} />
                    </Link>

                    <Link to="/order" className="quick-start-card">
                        <div className="quick-start-icon"><FiShoppingCart size={24} /></div>
                        <div className="quick-start-content">
                            <h4>{t('order_button')}</h4>
                            <p>{t('quick_start_order_desc')}</p>
                        </div>
                        <FiArrowRight className="quick-start-arrow" size={18} />
                    </Link>

                    <Link to="/documents" className="quick-start-card">
                        <div className="quick-start-icon"><FiFileText size={24} /></div>
                        <div className="quick-start-content">
                            <h4>{t('documents_title')}</h4>
                            <p>{t('quick_start_docs_desc')}</p>
                        </div>
                        <FiArrowRight className="quick-start-arrow" size={18} />
                    </Link>
                </div>
            </div>


            {/* Organizations Partners Section */}
            <div className="organizations-section">
                <h3 className="organizations-section-title">
                    {t('organizations_partners_title')}
                </h3>
                <div className="organizations-grid">
                    <a href="https://ott.ru/" target="_blank" rel="noopener noreferrer" className="organization-card-link">
                        <div className="organization-card">
                            <div className="org-logo-container">
                                <img
                                    src={require("../img/logo.jpg")}
                                    alt="НИИ АГиР им. Д.О. Отта"
                                    className="org-logo"
                                />
                            </div>
                            <div className="org-info">
                                <h4>{t('organization_ott_full')}</h4>
                                <p className="org-location">{t('organization_ott_location')}</p>
                            </div>
                        </div>
                    </a>

                    <a href="https://med-gen.ru" target="_blank" rel="noopener noreferrer" className="organization-card-link">
                        <div className="organization-card">
                            <div className="org-logo-container">
                                <img
                                    src={require("../img/mgnc.jpg")}
                                    alt="МГНЦ"
                                    className="org-logo"
                                />
                            </div>
                            <div className="org-info">
                                <h4>{t('organization_mgnc_full')}</h4>
                                <p className="org-location">{t('organization_mgnc_location')}</p>
                            </div>
                        </div>
                    </a>

                    <a href="https://www.surgu.ru" target="_blank" rel="noopener noreferrer" className="organization-card-link">
                        <div className="organization-card">
                            <div className="org-logo-container">
                                <img
                                    src={require("../img/surgu.png")}
                                    alt="СурГУ"
                                    className="org-logo"
                                />
                            </div>
                            <div className="org-info">
                                <h4>{t('organization_sur_full')}</h4>
                                <p className="org-location">{t('organization_sur_location')}</p>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
};
export default Main;